if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails) return;

        /*
        ======================================
          DAWN DEFAULT GALLERY EVENTS
        ======================================
        */

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );


        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
        /*
        ======================================
          CUSTOM SWIPER GALLERY
        ======================================
        */

        if (this.dataset.desktopLayout === 'custom-slider') {


          // Main slider
          this.mainSliderElement =
            this.querySelector('.product-media-slider');


          // Thumbnail slider
          this.thumbSliderElement =
            this.querySelector('.thumbnail-slider');


          if (!this.mainSliderElement || !this.thumbSliderElement) {
            return;
          }


          // Wrappers
          this.mainWrapper =
            this.mainSliderElement.querySelector('.swiper-wrapper');


          this.thumbWrapper =
            this.thumbSliderElement.querySelector('.swiper-wrapper');


          // Save original slides
          this.originalMainSlides =
            Array.from(this.mainWrapper.children)
              .map((slide) => slide.cloneNode(true));


          this.originalThumbSlides =
            Array.from(this.thumbWrapper.children)
              .map((slide) => slide.cloneNode(true));


          // Initialize Swiper
          this.initCustomSlider();

        }

      }


            /*
      ======================================
        INITIALIZE CUSTOM SWIPER
      ======================================
      */
      initCustomSlider() {

        // Destroy old Swipers before rebuild
        if (this.mainSwiper) {
          this.mainSwiper.destroy(true, true);
        }

        if (this.thumbSwiper) {
          this.thumbSwiper.destroy(true, true);
        }


        // Thumbnail Swiper
        this.thumbSwiper = new Swiper(this.thumbSliderElement, {
          spaceBetween: 0,
          slidesPerView: 'auto',
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          observer: true,
          observeParents: true,
          breakpoints: {
            768: {
              slidesPerView: 'auto',
              spaceBetween: 0,
            },
          },
        });


        // Main Swiper
        this.mainSwiper = new Swiper(this.mainSliderElement, {
          spaceBetween: 0,
          slidesPerView: 1,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: this.querySelector('.media-button-next'),
            prevEl: this.querySelector('.media-button-prev'),
          },
          thumbs: {
            swiper: this.thumbSwiper,
          },
          on: {
            slideChange: () => {
              this.scrollActiveThumb();
            },
          },
        });

      }

      scrollActiveThumb() {
        if (!this.thumbSwiper) return;

        const index = this.mainSwiper.realIndex;

        this.thumbSwiper.slideTo(index, 300);

        requestAnimationFrame(() => {
          this.thumbSwiper.update();
        });
      }


      /*
      ======================================
        FILTER MEDIA BY COLOR
      ======================================
      */
      filterMediaByColor(color,selectedMediaId) {

        console.log("FILTER CALLED:", color);
        console.trace("FILTER SOURCE");

        if (!this.mainWrapper || !this.thumbWrapper) {
          return;
        }


        const selectedColor = color
          ? color.toString().trim().toLowerCase()
          : '';


        // Find matching main images
        const mainSlides = this.originalMainSlides.filter((slide) => {
          return slide
            .getAttribute('data-alt')
            ?.toString()
            .trim()
            .toLowerCase() === selectedColor;
        });


        // Find matching thumbnails
        const thumbSlides = this.originalThumbSlides.filter((slide) => {
          return slide
            .getAttribute('data-alt')
            ?.toString()
            .trim()
            .toLowerCase() === selectedColor;
        });

        if(mainSlides.length != 0 && thumbSlides.length != 0){

          // If no media exists for selected color, show all
          const finalMainSlides =
            mainSlides.length
              ? mainSlides
              : this.originalMainSlides;

          const finalThumbSlides =
            thumbSlides.length
              ? thumbSlides
              : this.originalThumbSlides;

          // Remove existing slides
          this.mainWrapper.innerHTML = '';
          this.thumbWrapper.innerHTML = '';


          // Add main slides
          finalMainSlides.forEach((slide) => {
            this.mainWrapper.appendChild(
              slide.cloneNode(true)
            );
          });


          // Add thumbnail slides
          finalThumbSlides.forEach((slide) => {
            this.thumbWrapper.appendChild(
              slide.cloneNode(true)
            );
          });

  

          // Rebuild Swiper
          this.initCustomSlider();


          // Start from first image
          this.mainSwiper.slideTo(0);
          this.thumbSwiper.slideTo(0);

        }else{
          if(selectedMediaId != null){
            if(this.querySelector('.thumbnail-slider .thumbnail-list__item[data-media-id="'+selectedMediaId+'"]') != null){
              var goto_index = parseInt(this.querySelector('.thumbnail-slider .thumbnail-list__item[data-media-id="'+selectedMediaId+'"]').getAttribute('dada-swiper-index'));
              this.mainSwiper.slideTo(goto_index);
              this.thumbSwiper.slideTo(goto_index);
            }
          }
        }



      }


      /*
      ======================================
        DAWN SLIDE CHANGE EVENT
      ======================================
      */
      onSlideChanged(event) {

        // Disable Dawn thumbnail sync
        // for custom Swiper
        if (this.dataset.desktopLayout === 'custom-slider') {
          return;
        }


        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );


        this.setActiveThumbnail(thumbnail);

      }


      /*
      ======================================
        SET ACTIVE MEDIA
      ======================================
      */
     setActiveMedia(mediaId, prepend = false) {
  if (!mediaId || !this.mainSwiper || !this.mainWrapper) {
    return;
  }

  const targetMediaId = String(mediaId);

  const slides = Array.from(
    this.mainWrapper.querySelectorAll('.swiper-slide')
  );

  /*
   * Find the EXACT variant featured media.
   *
   * data-media-real-id contains the Shopify media.id.
   */
  let index = slides.findIndex((slide) => {
    return (
      String(slide.dataset.mediaRealId) === targetMediaId
    );
  });

  /*
   * Fallback for section-prefixed data-media-id.
   */
  if (index === -1) {
    index = slides.findIndex((slide) => {
      const mediaIdValue = String(
        slide.dataset.mediaId || ''
      );

      return (
        mediaIdValue === targetMediaId ||
        mediaIdValue.endsWith(`-${targetMediaId}`)
      );
    });
  }

  console.log(
    'TARGET MEDIA:',
    targetMediaId,
    'SWIPER INDEX:',
    index
  );

  /*
   * Exact media doesn't exist in current filtered slides.
   *
   * Restore original gallery and search again.
   */
  if (index === -1) {
    const originalIndex =
      this.originalMainSlides.findIndex((slide) => {
        return (
          String(slide.dataset.mediaRealId) ===
          targetMediaId
        );
      });

    if (originalIndex === -1) {
      console.log(
        'Variant featured media not found:',
        targetMediaId
      );
      return;
    }

    /*
     * Restore all media.
     */
    this.mainSwiper?.destroy(true, true);
    this.thumbSwiper?.destroy(true, true);

    this.mainWrapper.innerHTML = '';

    this.originalMainSlides.forEach((slide) => {
      this.mainWrapper.appendChild(
        slide.cloneNode(true)
      );
    });

    if (this.thumbWrapper) {
      this.thumbWrapper.innerHTML = '';

      this.originalThumbSlides.forEach((slide) => {
        this.thumbWrapper.appendChild(
          slide.cloneNode(true)
        );
      });
    }

    /*
     * Reinitialize.
     */
    this.initCustomSlider();

    /*
     * Find EXACT media again after restoring.
     */
    const restoredSlides = Array.from(
      this.mainWrapper.querySelectorAll('.swiper-slide')
    );

    index = restoredSlides.findIndex((slide) => {
      return (
        String(slide.dataset.mediaRealId) ===
        targetMediaId
      );
    });

    if (index === -1) {
      return;
    }
  }

  /*
   * Save current media.
   */
  this.currentMediaId = targetMediaId;

  /*
   * Update Swiper before moving.
   */
  this.mainSwiper.update();

  if (this.thumbSwiper) {
    this.thumbSwiper.update();
  }

  /*
   * IMPORTANT:
   *
   * Use slideTo(), NOT realIndex.
   * This is the actual DOM index of the variant media.
   */
  this.mainSwiper.slideTo(index, 0);

  if (
    this.thumbSwiper &&
    index < this.thumbSwiper.slides.length
  ) {
    this.thumbSwiper.slideTo(index, 0);
  }

  /*
   * Update active thumbnail.
   */
  this.mainSwiper.update();

  if (this.thumbSwiper) {
    this.thumbSwiper.update();
  }

  requestAnimationFrame(() => {
    this.scrollActiveThumb();
  });
}


      // setActiveMedia(mediaId, prepend) {


      //   // Custom slider controls media,
      //   // not Dawn
      //   if (this.dataset.desktopLayout === 'custom-slider') {
      //     return;
      //   }


      //   const activeMedia =
      //     this.elements.viewer.querySelector(
      //       `[data-media-id="${mediaId}"]`
      //     ) ||
      //     this.elements.viewer.querySelector(
      //       '[data-media-id]'
      //     );


      //   if (!activeMedia) {
      //     return;
      //   }


      //   this.elements.viewer
      //     .querySelectorAll('[data-media-id]')
      //     .forEach((element) => {
      //       element.classList.remove('is-active');
      //     });


      //   activeMedia.classList.add('is-active');

      //           if (prepend) {

      //     if (activeMedia.parentElement.firstChild !== activeMedia) {
      //       activeMedia.parentElement.prepend(activeMedia);
      //     }


      //     if (this.elements.thumbnails) {

      //       const activeThumbnail =
      //         this.elements.thumbnails.querySelector(
      //           `[data-target="${mediaId}"]`
      //         );


      //       if (
      //         activeThumbnail &&
      //         activeThumbnail.parentElement.firstChild !== activeThumbnail
      //       ) {
      //         activeThumbnail.parentElement.prepend(activeThumbnail);
      //       }

      //     }


      //     if (this.elements.viewer.slider) {
      //       this.elements.viewer.resetPages();
      //     }

      //   }


      //   this.preventStickyHeader();


      //   window.setTimeout(() => {

      //     if (!this.mql.matches || this.elements.thumbnails) {

      //       activeMedia.parentElement.scrollTo({
      //         left: activeMedia.offsetLeft,
      //       });

      //     }


      //     const activeMediaRect =
      //       activeMedia.getBoundingClientRect();


      //     // Do not scroll if already visible
      //     if (activeMediaRect.top > -0.5) {
      //       return;
      //     }


      //     window.scrollTo({
      //       top: activeMediaRect.top + window.scrollY,
      //       behavior: 'smooth',
      //     });


      //   });


      //   this.playActiveMedia(activeMedia);


      //   if (!this.elements.thumbnails) {
      //     return;
      //   }


      //   const activeThumbnail =
      //     this.elements.thumbnails.querySelector(
      //       `[data-target="${mediaId}"]`
      //     );


      //   if (activeThumbnail) {

      //     this.setActiveThumbnail(activeThumbnail);


      //     this.announceLiveRegion(
      //       activeMedia,
      //       activeThumbnail.dataset.mediaPosition
      //     );

      //   }

      // }


      /*
      ======================================
        SET ACTIVE THUMBNAIL
      ======================================
      */
      setActiveThumbnail(thumbnail) {


        // Custom Swiper handles thumbnail state
        if (this.dataset.desktopLayout === 'custom-slider') {
          return;
        }


        if (!this.elements.thumbnails || !thumbnail) {
          return;
        }


        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });


        thumbnail
          .querySelector('button')
          .setAttribute('aria-current', true);

        if (
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            10
          )
        ) {
          return;
        }
        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });

      }


      /*
      ======================================
        ANNOUNCE IMAGE TO SCREEN READER
      ======================================
      */
      announceLiveRegion(activeItem, position) {


        if (this.dataset.desktopLayout === 'custom-slider') {
          return;
        }


        const image =
          activeItem.querySelector(
            '.product__modal-opener--image img'
          );


        if (!image) {
          return;
        }


        image.onload = () => {

          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );


          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );


          setTimeout(() => {

            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );

          }, 2000);

        };


        image.src = image.src;

      }


      /*
      ======================================
        PLAY VIDEO / MODEL MEDIA
      ======================================
      */
      playActiveMedia(activeItem) {

        window.pauseAllMedia();


        const deferredMedia =
          activeItem.querySelector('.deferred-media');


        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }

      }


      /*
      ======================================
        PREVENT STICKY HEADER JUMP
      ======================================
      */
      preventStickyHeader() {

        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');


        if (!this.stickyHeader) {
          return;
        }


        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );

      }


      /*
      ======================================
        REMOVE LIST SEMANTICS
      ======================================
      */
      removeListSemantic() {


        if (!this.elements.viewer.slider) {
          return;
        }


        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );


        this.elements.viewer.sliderItems.forEach(
          (slide) => {
            slide.setAttribute(
              'role',
              'presentation'
            );
          }
        );

      }

    }
  );
}